(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lenora-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lh-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-lh-slide]'), tabs = hero.querySelectorAll('[data-lh-tab]'), imgs = hero.querySelectorAll('[data-lh-img]');
    var count = hero.querySelector('[data-lh-count]'), n = slides.length, i = 0, timer = null;
    var interval = (parseInt(hero.dataset.interval, 10) || 7) * 1000;
    hero.style.setProperty('--lh-interval', interval + 'ms');
    // 19 Oct 2026 (speed): a later slide's image is requested when it is first needed, never during the first paint
    function load(k) {
      var pic = imgs[(k + n) % n] && imgs[(k + n) % n].querySelector('[data-lh-deferred]');
      if (!pic) return;
      pic.querySelectorAll('source[data-srcset]').forEach(function (s) { s.srcset = s.dataset.srcset; s.removeAttribute('data-srcset'); });
      var im = pic.querySelector('img[data-src]');
      if (im) { if (im.dataset.srcset) im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); im.removeAttribute('data-srcset'); }
      pic.removeAttribute('data-lh-deferred');
    }
    function show(k) {
      hero.classList.add('lh-hero--ready');            /* 20 Oct 2026: the crossfade and the slide fade only from the first change on */
      i = (k + n) % n;
      load(i); load(i + 1);
      slides.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
      imgs.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
      tabs.forEach(function (el, j) {
        el.classList.toggle('is-active', j === i);
        var fill = el.querySelector('.lh-hero__bar-fill'); if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
      });
      if (count) count.textContent = ('0' + (i + 1)).slice(-2);
    }
    function start() { stop(); timer = setInterval(function () { show(i + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    tabs.forEach(function (el, j) { el.addEventListener('click', function () { show(j); start(); }); });
    var prev = hero.querySelector('[data-lh-prev]'), next = hero.querySelector('[data-lh-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    hero.addEventListener('mouseenter', function () { stop(); hero.setAttribute('data-paused', ''); });
    hero.addEventListener('mouseleave', function () { hero.removeAttribute('data-paused'); if (armed) start(); });
    // 19 Oct 2026 (speed): the rotation used to begin at once, so on a phone the second slide fading in at 7 s was
    // counted as the page's largest paint (LCP 11 s). It now begins on the first touch, wheel, key or click — or
    // 8 s after the page has fully loaded — and the next slide's image is fetched just before it is needed.
    var armed = false;
    function arm() { if (armed || n < 2) return; armed = true; load(1); if (!hero.hasAttribute('data-paused')) start(); }
    ['touchstart', 'wheel', 'keydown', 'pointerdown'].forEach(function (ev) { window.addEventListener(ev, arm, { once: true, passive: true }); });
    if (document.readyState === 'complete') setTimeout(arm, 8000); else window.addEventListener('load', function () { setTimeout(arm, 8000); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lenora-pack-builder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lh-pb]').forEach(function (root) {
    var tiers = JSON.parse(root.dataset.tiers), t = JSON.parse(root.dataset.t || '{}');
    var fmt = root.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
    var onTariff = root.dataset.tariff === 'true';
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-lh-pb-row]'));
    var addBtn = root.querySelector('[data-lh-pb-add]'), msg = root.querySelector('[data-lh-pb-msg]');
    function money(cents) {
      var v = (cents / 100).toFixed(2), parts = v.split('.'), intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var out = fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, intp + ',' + parts[1])
                   .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, intp)
                   .replace(/\{\{\s*amount\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1])
                   .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
      return out.replace(/<[^>]+>/g, '');
    }
    function variantOf(line) {
      var sel = line.querySelector('[data-lh-pb-variant]'), o = sel.options[sel.selectedIndex];
      return { id: parseInt(o.value, 10), price: parseInt(o.dataset.price, 10), pack: Math.max(1, parseInt(o.dataset.pack, 10) || 1), available: o.dataset.available === 'true' };
    }
    function linesOf(row) { return Array.prototype.slice.call(row.querySelectorAll('[data-lh-pb-lines] [data-lh-pb-l]')); }
    function qtyOf(line) { return parseInt(line.querySelector('[data-lh-pb-qty]').value, 10) || 0; }
    function note(row, text) { var n = row.querySelector('[data-lh-pb-note]'); if (n) n.textContent = text || ''; }
    /* the pack rule, exactly as the product page keeps it: 0 = not chosen; otherwise at least one pack, and
       always a whole number of packs — a typed quantity goes UP to the next multiple */
    function fit(n, pack) { n = Math.round(n) || 0; if (n <= 0) return 0; return Math.max(pack, Math.ceil(n / pack) * pack); }
    function renderLine(line, many) {
      var v = variantOf(line), qty = line.querySelector('[data-lh-pb-qty]');
      var q = v.available ? fit(parseInt(qty.value, 10), v.pack) : 0;
      qty.value = q; qty.step = v.pack; qty.min = 0; qty.disabled = !v.available;
      line.querySelector('[data-lh-pb-price]').textContent = money(v.price) + ' / ' + t.unit;
      line.querySelector('[data-lh-pb-pack]').textContent = v.available ? (v.pack > 1 ? '· ' + t.pack.replace(/\{n\}/g, v.pack) : '') : '· ' + t.soldOut;
      line.querySelector('[data-lh-pb-line]').textContent = q ? money(q * v.price) : '';
      /* the only line of an article is emptied rather than removed: its remove button shows once there is something to remove */
      line.querySelector('[data-lh-pb-rm]').hidden = !many && !q;
      return { id: v.id, quantity: q, cents: q * v.price };
    }
    function render() {
      var byId = {}, order = [];
      rows.forEach(function (row) {
        var ls = linesOf(row), on = false;
        ls.forEach(function (line) {
          var l = renderLine(line, ls.length > 1);
          if (!l.quantity) return;
          on = true;
          /* the same variant may sit in two groups: one cart line, the quantities added */
          if (byId[l.id]) { byId[l.id].quantity += l.quantity; byId[l.id].cents += l.cents; }
          else { byId[l.id] = l; order.push(l.id); }
        });
        row.classList.toggle('is-on', on);
      });
      var lines = order.map(function (id) { return byId[id]; });
      var subtotal = lines.reduce(function (a, l) { return a + l.cents; }, 0), units = lines.reduce(function (a, l) { return a + l.quantity; }, 0);
      root.querySelector('[data-lh-pb-summary]').textContent = lines.length ? t.summary.replace('{n}', lines.length).replace('{u}', units) : t.empty;
      root.querySelector('[data-lh-pb-subtotal]').textContent = money(subtotal);
      if (!onTariff) {
        var idx = 0; tiers.forEach(function (tier, i) { if (subtotal >= tier.min * 100) idx = i; });
        var pct = tiers[idx].pct, discount = Math.round(subtotal * pct / 100);
        root.querySelector('[data-lh-pb-pct]').textContent = pct + '%';
        root.querySelector('[data-lh-pb-discount]').textContent = '−' + money(discount);
        root.querySelector('[data-lh-pb-total]').textContent = money(subtotal - discount);
        var hint = root.querySelector('[data-lh-pb-hint]');
        if (!lines.length) hint.textContent = '';
        else if (idx < tiers.length - 1) hint.textContent = t.hintMore.replace('{e}', money(tiers[idx + 1].min * 100 - subtotal)).replace('{p}', tiers[idx + 1].pct);
        else hint.textContent = t.hintMax;
      }
      addBtn.disabled = !lines.length;
      root.querySelector('[data-lh-pb-bar]').classList.toggle('is-empty', !lines.length);
      return lines;
    }
    function addLine(row, variantId) {
      var line = row.querySelector('[data-lh-pb-tpl]').content.firstElementChild.cloneNode(true);
      var sel = line.querySelector('[data-lh-pb-variant]'), qty = line.querySelector('[data-lh-pb-qty]');
      if (variantId) sel.value = String(variantId);
      row.querySelector('[data-lh-pb-lines]').appendChild(line);
      var last = variantOf(line).id;
      line.querySelector('[data-lh-pb-minus]').addEventListener('click', function () { var v = variantOf(line); qty.value = Math.max(0, (parseInt(qty.value, 10) || 0) - v.pack); msg.textContent = ''; render(); });
      line.querySelector('[data-lh-pb-plus]').addEventListener('click', function () { var v = variantOf(line); qty.value = (parseInt(qty.value, 10) || 0) + v.pack; msg.textContent = ''; note(row); render(); });
      qty.addEventListener('change', function () { msg.textContent = ''; render(); });
      sel.addEventListener('change', function () {
        var v = variantOf(line);
        msg.textContent = ''; note(row);
        /* the same variant on another line of this article: one line, the quantities added and fitted to the pack */
        var twin = linesOf(row).filter(function (o) { return o !== line && variantOf(o).id === v.id; })[0];
        if (twin) {
          var tq = twin.querySelector('[data-lh-pb-qty]');
          tq.value = fit(qtyOf(twin) + qtyOf(line), v.pack);
          line.remove(); note(row, t.merged); render(); tq.focus();
          return;
        }
        /* another variant may be sold in another pack: a quantity already chosen starts again at one pack */
        if (v.id !== last && (parseInt(qty.value, 10) || 0) > 0) qty.value = v.pack;
        last = v.id; render();
      });
      line.querySelector('[data-lh-pb-rm]').addEventListener('click', function () {
        msg.textContent = ''; note(row);
        if (linesOf(row).length > 1) { line.remove(); }
        else { qty.value = 0; }
        render();
      });
      return line;
    }
    rows.forEach(function (row) {
      addLine(row);
      var more = row.querySelector('[data-lh-pb-more]');
      if (!more) return;
      more.addEventListener('click', function () {
        msg.textContent = ''; note(row);
        /* the new line opens on the first variant on sale that no line of this article has yet */
        var used = linesOf(row).map(function (l) { return variantOf(l).id; });
        var opts = Array.prototype.slice.call(row.querySelector('[data-lh-pb-tpl]').content.querySelectorAll('option'));
        var free = opts.filter(function (o) { return o.dataset.available === 'true' && used.indexOf(parseInt(o.value, 10)) < 0; })[0];
        if (!free) { note(row, t.allUsed); return; }
        var line = addLine(row, free.value);
        render();
        line.querySelector('[data-lh-pb-variant]').focus();
      });
    });
    addBtn.addEventListener('click', function () {
      var lines = render();
      if (!lines.length) { msg.textContent = t.empty; return; }
      addBtn.disabled = true; msg.textContent = '';
      fetch(root.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: l.quantity }; }) }) })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) { msg.textContent = (res.body && (res.body.description || res.body.message)) || t.error; addBtn.disabled = false; return; }
          window.location.href = root.dataset.cartUrl;      /* the cart is the source of truth: quantities, the automatic discount, the total */
        })
        .catch(function () { msg.textContent = t.error; addBtn.disabled = false; });
    });
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
